import React from "react";
import { Box, Heading, Link } from "@chakra-ui/react";
import Card from "./Card";
import DownloadApp from "./DownloadApp";

const blogCards = [
  // 4 from BlogSection
  {
    title: "Best International Money Transfer Apps in 2026",
    description: <Link href="/blog/best-transfer-apps-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/money_transfer.png"),
    ref:"/blog/best-transfer-apps-2026",
  },
  {
    title: "Top 10 Strongest Currencies in the World",
    description: <Link href="/blog/top-10-strongest-currencies-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_map.png"),
    ref:"/blog/top-10-strongest-currencies-2026",
  },
  {
    title: "Avoiding Currency Exchange Scams While Traveling",
    description: <Link href="/blog/avoiding-currency-exchange-scams" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/currency_exchange.png"),
    ref:"/blog/avoiding-currency-exchange-scams",
  },
  {
    title: "Cheapest Destinations to Visit by Season",
    description: <Link href="/blog/cheapest-destinations-by-season" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/destination.png"),
    ref:"/blog/cheapest-destinations-by-season",
  },
  // 8 additional cards
  {
    title: "Top 7 Countries to relocate to in 2026",
    description: <Link href="/blog/top-7-countries-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/top_relocate_countries_2026.png"),
    ref:"/blog/top-7-countries-2026",
  },
 {
    title: "Understanding Exchange Rates: A Beginner's Guide",
   description: <Link href="/blog/understanding-exchange-rates" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/exchange_rate.png"),
    ref:"/blog/understanding-exchange-rates",
  },
   {
    title: "Immigration routes to Canada in 2026",
    description: <Link href="/blog/immigration-routes-canada-2026" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/canada_immigration.png"),
    ref:"/blog/immigration-routes-canada-2026"
  },
  {
    title: "How to Avoid Hidden Fees When Sending Money",
    description: <Link href="/blog/avoid-hidden-fees-sending-money" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/hidden_fees.png"),
    ref:"/blog/avoid-hidden-fees-sending-money",
  },
  
  {
    title: "Tips for Safe Online Money Transfers",
    description: <Link href="/blog/safe-online-money-transfers" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/safe_transfer.png"),
    ref:"/blog/safe-online-money-transfers",
  },

  
  /*{
    title: "Digital Wallets vs. Traditional Banking",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/digital_wallet.png"),
  },
  
  {
    title: "The Rise of Fintech in Africa",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/fintech_africa.png"),
  },
  {
    title: "What to Know before choosing a cross-border transfer app",
    description: <Link href="#" color="teal.500">Read more</Link>,
    getImageSrc: () => require("../images/remittance_laws.png"),
  },*/
];

export default function Blog() {
  return (
    <Box maxW="1500px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 24, md: 40 }}>
      <Heading as="h1" size="2xl" mb={2} textAlign="center">
        Swiftchang Blog
      </Heading>
      <Box mb={16} textAlign="center">
        <span style={{ fontSize: '1.2rem', color: '#4A5568' }}>
          Insights, tips, and updates on global money transfer, fintech, and financial empowerment.
        </span>
      </Box>
      <Box
        display="grid"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,minmax(0,1fr))", lg: "repeat(4,minmax(0,1fr))" }}
        gridGap={{ base: 6, md: 8 }}
        maxWidth="1500px"
        margin="0 auto"
      >
        {blogCards.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
            imageBorder="2px solid #d3d3d3"
            imageHref={project.ref}
          />
        ))}
      </Box>
        
      <DownloadApp heading = "Download the app On Launch date (March 20, 2026) to refer!"/>
      
    </Box>
  );
}
